import GlossaryDetailedScreenShader from "../../shaders/glossaryScreen/GlossaryDetailedScreenShader";
import GlossaryDetailedTermDefinition from "./GlossaryDetailedTermDefinition";
import GlossaryDetailedTermExample from "./GlossaryDetailedTermExample";
import {get_nested} from "../../../services/JsonHandler";

export default function GlossaryDetailedScreenDefinition({term}) {
    // Used in GlossaryDetailedScreenContent to display Term definition

    // PROPERTIES
    const termPictureUrl = get_nested(['termExamplePicture', 'filePath'], term, null)

    // BUILD
    return (
        <div className="bg-backgroundLight3 overflow-auto h-full relative px-[16px] pb-[16px] mt-[4px]">
            <GlossaryDetailedScreenShader />
            <GlossaryDetailedTermDefinition definition={term.definition} />
            <GlossaryDetailedTermExample example={term.example}
                                         termPictureUrl={termPictureUrl} />
        </div>
    );
}